import * as React from "react";
import { forwardRef } from "react";
const SvgMountainSnow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-mountain-snow-icon lucide-mountain-snow", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }), /* @__PURE__ */ React.createElement("path", { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19" }));
const ForwardRef = forwardRef(SvgMountainSnow);
export default ForwardRef;
